export default {
      id: "delete-usage",
      viewBox: "0 0 23 25",
      url: __webpack_public_path__ + "sprite.svg#delete",
      toString: function () {
        return this.url;
      }
    }